import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { UserSessionService } from '@com-delta-idp/mnx-oauth';
import {
  ContentBodyAbodeSupportAnalytics,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { Subject, Subscription, forkJoin } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ApplicationConfig } from '../../config/config';
import { SwitchingAccountService } from '../../header/switching-account/switching-account.service';
import { ContentAccessibilityPopup } from '../../model/content/contentAccessibilityPopup.model';
import { ContentDarkSite } from '../../model/content/contentDarkSite.model';
import { PERequest } from '../../model/userdata-model';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { ClosestAirPortcode } from '../../services/closestairportcode.service';
import { CommonService } from '../../services/common.service';
import { ContentBodyService } from '../../services/content/contentbody.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { FlyoutExternalSiteService } from '../../services/flyout-externalsite-service/flyout-externalsite.service';
import { CookieHelper } from '../cookie-helper';
import { ContentBodyClickEventAnalyticsUtils } from './content-body-analytics-utils';
import { processContentAnalytics } from './content-body-process-analytics';
import {
  AnalyticsUser,
  ClickEventAnalytics,
  SHOPPING_BAND,
  removeDomainName
} from '@com-delta-idp/mnx-utils';

declare let delta: any;
declare let picturefillBackground: any;
declare let makeMboxVisible: any;

@Component({
  selector: 'ngc-content-body',
  templateUrl: 'content-body.html'
})
/**
 * This is the fragment which contains the Content Body from the Homepage Fragment
 */
export class ContentBodyComponent
  implements OnInit, AfterViewChecked, OnDestroy, OnChanges
{
  contentFragment: string;
  axPopupContent: ContentAccessibilityPopup;
  frag: DocumentFragment;
  peRequest: PERequest;
  public darkSiteThemeContent: ContentDarkSite;
  isEnabled = 'true';
  isDarkSiteEnabled = true;
  displayBody = true;
  contentServiceHeaderFooterSubscribe: Subscription;
  svcLoadHtmlFragmentSubcription: Subscription;
  contentLoaded = false;
  headerText: string;
  public timeouts = [];
  public multicampainId = [];
  corpName: string;
  pageLoadStartTime = 0;
  public businessAccountIndex = 0;
  private unsubscribe: Subject<void> = new Subject();
  darkSiteLevel = '';

  @Input() reRender = false;

  @Output() bodySkeleton = new EventEmitter<boolean>(true);

  constructor(
    private svc: ContentBodyService,
    private closetAirportSvc: ClosestAirPortcode,
    private acctSummarySvr: AccountSummaryService,
    private commonSvc: CommonService,
    private _config: ApplicationConfig,
    public switchingAccountService: SwitchingAccountService,
    private contentService: ContentHeaderFooterService,
    private cdf: ChangeDetectorRef,
    private elementRef: ElementRef,
    private cookieHelper: CookieHelper,
    private rend: Renderer2,
    private flyoutExternalSiteService: FlyoutExternalSiteService,
    private userSession: UserSessionService,
    private contentBodyClickEventAnalyticsUtils: ContentBodyClickEventAnalyticsUtils,
    private contentBodyAbodeSupportAnalytics: ContentBodyAbodeSupportAnalytics,
    @Inject(PLATFORM_ID) private platformId: Object,
    private loggingService: LoggingService
  ) {
    this.contentFragment = '';
  }

  ngOnInit(): void {
    if (this._config.onBrowser) {
      if (this._config.get('ENABLE_OPTIMIZED_PE')) {
        this.homeContentHtmlPeRes();
      } else {
        this.getPE();
      }
      // this.peRequest = new PERequest();
      // this.svcLoadHtmlFragmentSubcription = this.svc.loadHtmlFragment()
      //   .takeUntil(this.unsubscribe)
      //   .subscribe((res) => {
      //     this.contentFragment = res;
      //     this.contentLoaded = true;
      //     try {
      //       this.getPEContent(res);
      //     } catch (err) {
      //      this.loggingService.log('Caught Error: ' + err);
      //     }
      //   }, err => {
      //     this.loggingService.log('Caught Error: ' + err);
      //   });
      // if (this.contentService.contentHeaderFooter) {
      //   this.contentServiceHeaderFooterSubscribe = this.contentService.contentHeaderFooter
      //     .takeUntil(this.unsubscribe)
      //     .subscribe(data => {
      //       if (data) {
      //         if (data.darkSite) {
      //           this.darkSiteThemeContent = data.darkSite;
      //           if (this.darkSiteThemeContent.isEnabled === this.isEnabled) {
      //             this.contentFragment = null;
      //             if (this.darkSiteThemeContent.level === this._config.get('APP_DARKSITE_LEVEL_0')) {
      //               this.isDarkSiteEnabled = false;
      //             } else {
      //               this.isDarkSiteEnabled = true;
      //             }
      //           }
      //         }
      //       }
      //     }, err => {
      //       this.loggingService.log('Caught Error: ' + err);
      //     });
      // }
      this.switchingAccountService.displayBody.subscribe((displayBody) => {
        this.displayBody = !displayBody;
        if (this.displayBody) {
          if (this._config.get('ENABLE_OPTIMIZED_PE')) {
            this.homeContentHtmlPeRes();
          } else {
            this.getPE();
          }
        }
      });
    }
  }

  open(hrefUrl) {
    this.flyoutExternalSiteService.openFlyoutExtSiteModal(
      hrefUrl,
      this.elementRef,
      this.rend
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId)) {
      this.listenToEvents();
    }
  }

  listenToEvents() {
    // TODO: needs to refactor code - B-664953
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('service-worker-token', () => {
        if (this._config.get('ENABLE_OPTIMIZED_PE')) {
          this.acctSummarySvr.getAccountSummaryDetails().subscribe((res) => {
            if (res?.loggedIn) {
              this.peRequest = new PERequest();
              this.peRequest?.populateUserData(res);
              this.homeContentHtmlPeRes();
            }
          });
        } else {
          this.getPE();
        }
      });
    }
  }

  headerFooterContentHelper(): void {
    this.contentService._isHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((headerFooterFlag) => {
        if (headerFooterFlag) {
          if (this.contentService.contentHeaderFooter) {
            this.contentServiceHeaderFooterSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (data) => {
                    if (data) {
                      this.axPopupContent = data.accessibilityPopup;
                      this.headerText = data.axBrandName;
                      this.commonSvc.setAxPopupContent(this.axPopupContent);
                      if (data.darkSite) {
                        this.darkSiteThemeContent = data.darkSite;
                        if (
                          this.darkSiteThemeContent.isEnabled === this.isEnabled
                        ) {
                          //this.contentFragment = null;
                          if (
                            this.darkSiteThemeContent.level ===
                            this._config.get('APP_DARKSITE_LEVEL_0')
                          ) {
                            this.isDarkSiteEnabled = false;
                          } else {
                            this.isDarkSiteEnabled = true;
                          }
                          this.darkSiteLevel =
                            this.darkSiteThemeContent.enableBlackTheme ===
                            'true'
                              ? this.darkSiteThemeContent.level
                              : '';
                        }
                      }
                      this.cdf.detectChanges();
                    }
                  },
                  (err) => {
                    this.loggingService.log('Caught Error: ' + err);
                  }
                );
          }
        }
      });
  }

  processContentAnalytics = (
    contentDiv: HTMLElement | null,
    startTime: number,
    getCountryAndLanguage: {
      v39: string;
      v40: string;
    }
  ): void => {
    if (!contentDiv) return;

    const site_assets = processContentAnalytics(
      contentDiv,
      this.contentBodyAbodeSupportAnalytics,
      (componentType, idx) =>
        this.contentBodyAbodeSupportAnalytics.computePageLoadAssetID(
          componentType,
          idx
        )
    );

    const endTime = performance.now();
    const durationMs = endTime - startTime;
    const durationSec = durationMs / 1000;

    this.contentBodyClickEventAnalyticsUtils.setHomePageLoadAssetAnalytics(
      site_assets,
      getCountryAndLanguage.v39,
      getCountryAndLanguage.v40,
      durationSec.toFixed(2)
    );
  };

  setPrefContent(): {
    v39: string;
    v40: string;
  } {
    window['targetDataElement'] = window['targetDataElement']
      ? window['targetDataElement']
      : {};
    window['targetDataElement'].profile = window['targetDataElement'].profile
      ? window['targetDataElement'].profile
      : {};

    const getPrefCookie = this.cookieHelper.getCookies('prefUI');
    let getCountryAndLanguage = {
      v39: '',
      v40: ''
    };
    if (getPrefCookie && getPrefCookie !== '') {
      let prefCookie = getPrefCookie.split('=');
      prefCookie = prefCookie[1].split('-');
      window['targetDataElement'].profile.mp_country = prefCookie[1];
      window['targetDataElement'].profile.mp_lang = prefCookie[0];
      getCountryAndLanguage = {
        v39: prefCookie[0],
        v40: prefCookie[1]
      };
      return getCountryAndLanguage;
    } else {
      window['targetDataElement'].profile = {
        mp_country: 'us',
        mp_lang: 'en'
      };
      getCountryAndLanguage = {
        v39: 'en',
        v40: 'us'
      };
      return getCountryAndLanguage;
    }
  }

  createPersonalizationDiv(): void {
    const personalizationDiv = this.rend.createElement('div');
    this.rend.addClass(personalizationDiv, 'personalizationcontent');
    this.rend.setAttribute(
      personalizationDiv,
      'id',
      'homepage:banner-promoquilt'
    );
    this.rend.appendChild(this.elementRef.nativeElement, personalizationDiv);
  }

  homeContentHtmlPeRes(): void {
    const startTime = performance.now();
    this.createPersonalizationDiv();
    const perReqs = this.elementRef.nativeElement.querySelectorAll(
      '.personalizationcontent'
    );
    let getCountryAndLanguage = this.setPrefContent();
    this.svcLoadHtmlFragmentSubcription = this.svc
      .loadHtmlFragment()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((response: any) => {
        this.contentFragment = response;
        this.contentLoaded = true;
        try {
          if (response && !response.includes('error')) {
            const doc = new DOMParser().parseFromString(response, 'text/html');
            setTimeout(() => {
              const perReqsElement = document.querySelector(
                '.homePageTitle.d-none'
              ).nextElementSibling;

              // Process analytics early to capture accurate timing before DOM manipulation
              this.processContentAnalytics(
                perReqsElement as HTMLElement,
                startTime,
                getCountryAndLanguage
              );
            }, 0);

            for (let i = 0; i < perReqs.length; i++) {
              const personalizeDiv = document.getElementById(perReqs[i].id);
              let respCampId;
              if (perReqs[i].id.indexOf(':') >= 0) {
                const arr = perReqs[i].id.split(':');
                respCampId = arr[0] + '\\:' + arr[1];
              }
              const persResp = document.getElementById(
                'homepage:banner-promoquilt'
              )?.innerHTML;

              if (personalizeDiv) {
                if (
                  personalizeDiv.innerHTML.includes('bussiness-alert-banner')
                ) {
                  personalizeDiv.innerHTML += this.updateResponse(
                    persResp,
                    perReqs[i].id
                  );
                } else {
                  personalizeDiv.innerHTML = this.updateResponse(
                    persResp,
                    perReqs[i].id
                  );
                }
                this.contentLoaded = true;
              }
            }
          }
        } catch (err) {
          this.loggingService.log('Caught Error: ' + err);
        }
        this.bodySkeleton.emit(false);
        this.customEvent_HeroContent();
        this.setupShoppingBandAnalytics();
      });
    this.headerFooterContentHelper();
  }

  getPE() {
    this.peRequest = new PERequest();
    this.svcLoadHtmlFragmentSubcription = this.svc
      .loadHtmlFragment()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (res) => {
          this.contentFragment = res;
          this.contentLoaded = true;
          try {
            if (
              this._config.get('APP_HERO_PECALL') &&
              this._config.get('APP_HERO_PECALL') === 'true'
            ) {
              this.getPEContent(res); // removed timout dcore590 and corpname handled in cookie
            } else {
              setTimeout(() => {
                // added timer to make it wait until the businessInfo gets initialized
                this.getPEContent(res);
              }, 2000);
            }
          } catch (err) {
            this.loggingService.log('Caught Error: ' + err);
          }
          /* KEY-225 - Fire Custom Events for Hero Content*/
          if (this.contentLoaded) {
            /* dcore124 */
            this.customEvent_HeroContent();
            this.setupShoppingBandAnalytics();
          }
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
    this.headerFooterContentHelper();
  }

  getPEContent(res: any) {
    if (res && this._config.onBrowser && document) {
      this.frag = document.createRange().createContextualFragment(res);
      const perReqs = this.frag.querySelectorAll('.personalizationcontent');
      if (perReqs && perReqs.length > 0) {
        if (this.userSession.getServiceWorkerCheck()) {
          this.getPEContentHelper(perReqs);
        }
      }
    }
  }

  getPEContentHelper(perReqs: NodeListOf<Element>) {
    const startTime = performance.now();
    const geoLocation = this.closetAirportSvc.getClosestDeltaAirportCode();
    const custDashBrd = this.acctSummarySvr.getAccountSummaryDetails();
    forkJoin([geoLocation, custDashBrd]).subscribe(
      (results) => {
        this.peRequest.populateUserData(results[0]);
        this.peRequest.populateUserData(results[1]);
        window['targetDataElement'] = window['targetDataElement']
          ? window['targetDataElement']
          : {};
        window['targetDataElement'].profile = window['targetDataElement']
          .profile
          ? window['targetDataElement'].profile
          : {};

        const getPrefCookie = this.cookieHelper.getCookies('prefUI');
        let getCountryAndLanguage = {
          v39: '',
          v40: ''
        };
        if (getPrefCookie && getPrefCookie !== '') {
          let prefCookie = getPrefCookie.split('=');
          prefCookie = prefCookie[1].split('-');
          window['targetDataElement'].profile.mp_country = prefCookie[1];
          window['targetDataElement'].profile.mp_lang = prefCookie[0];
          getCountryAndLanguage = {
            v39: prefCookie[0],
            v40: prefCookie[1]
          };
          this.peRequest.populateUserData(getCountryAndLanguage);
        } else {
          window['targetDataElement'].profile = {
            mp_country: 'us',
            mp_lang: 'en'
          };
        }
        const businessUserInfo = this.switchingAccountService.getUserInfo();
        const accountCookie = this.cookieHelper.getCookieValue('account');
        const corpCookie = Object.assign(
          {},
          { hasCookie: this.cookieHelper.getCookies('corp') ? true : false }
        );
        let fromIntranetLink = false;
        if (accountCookie && accountCookie.length) {
          const parseAccount = JSON.parse(accountCookie);
          const businessAccountOptionsList =
            parseAccount['businessAccountOptionsList'];
          this.businessAccountIndex = businessAccountOptionsList['accountIndex']
            ? parseInt(businessAccountOptionsList['accountIndex'])
            : 0;
        } else if (corpCookie.hasCookie) {
          fromIntranetLink = true;
        }
        const dashBrdData = results[1];
        if (dashBrdData) {
          const types: string[] = dashBrdData.crprtAgrmntTypeCode
            ? dashBrdData.crprtAgrmntTypeCode.split('|')
            : null;
          const contractMgtEnt: string[] = dashBrdData.contractMgtEnt
            ? dashBrdData.contractMgtEnt.split('|')
            : null;
          const program: string[] = dashBrdData.program
            ? dashBrdData.program.split('|')
            : null;
          const id: string[] = dashBrdData.crprtAgrmntId
            ? dashBrdData.crprtAgrmntId.split('|')
            : null;
          if (fromIntranetLink) {
            this.switchingAccountService.setAdditionalBusinessUserInfo(
              null,
              null,
              null,
              null
            );
          } else if (types && contractMgtEnt && program) {
            this.switchingAccountService.setAdditionalBusinessUserInfo(
              types[this.businessAccountIndex],
              contractMgtEnt[this.businessAccountIndex],
              program[this.businessAccountIndex],
              id[this.businessAccountIndex]
            );
          }
        }
        const additionalBusinessInfo =
          this.switchingAccountService.getAdditionalBusinessUserInfo();
        this.peRequest.populateUserData(businessUserInfo);
        this.peRequest.populateUserData(additionalBusinessInfo);
        for (let i = 0; i < perReqs.length; i++) {
          if (perReqs[i] && perReqs[i].id && perReqs[i].id !== undefined) {
            const campainId = perReqs[i].id;
            this.multicampainId.push(campainId); // multiple PE call endpoint to have request with campId as array in single call
          }
        }
        this.peRequest.populateRequestParam(this.multicampainId, 'html'); // multiplePE call
        this.svc
          .loadPEDataWithHtmlRes(this.peRequest)
          .subscribe((response: any) => {
            try {
              if (response && !response.includes('error')) {
                const doc = new DOMParser().parseFromString(
                  response,
                  'text/html'
                );
                for (let i = 0; i < perReqs.length; i++) {
                  const personalizeDiv = document.getElementById(perReqs[i].id);
                  let respCampId;
                  if (perReqs[i].id.indexOf(':') >= 0) {
                    const arr = perReqs[i].id.split(':');
                    respCampId = arr[0] + '\\:' + arr[1];
                  }
                  const persResp = doc.querySelector(
                    '#' + respCampId
                  ).innerHTML;
                  if (personalizeDiv) {
                    if (
                      personalizeDiv.innerHTML.includes(
                        'bussiness-alert-banner'
                      )
                    ) {
                      personalizeDiv.innerHTML += this.updateResponse(
                        persResp,
                        perReqs[i].id
                      );
                    } else {
                      personalizeDiv.innerHTML = this.updateResponse(
                        persResp,
                        perReqs[i].id
                      );
                    }
                    this.contentLoaded = true;
                  }
                }
              }
            } catch (err) {
              this.loggingService.log('Caught Error: ' + err);
            }
            this.bodySkeleton.emit(false);
            this.setupShoppingBandAnalytics();
          });
      },
      (err) => {
        // this.loggingService.log('Caught Error: ' + err);
      }
    );
  }

  picturefillBackground(): void {
    if (typeof picturefillBackground === 'function') {
      picturefillBackground();
    }
  }

  ngAfterViewChecked(): void {
    const handle: ContentBodyComponent = this;
    if (this.contentLoaded) {
      try {
        handle.picturefillBackground();
        this.timeouts.push(
          setTimeout(() => {
            makeMboxVisible();
            handle.picturefillBackground();
          }, 1000)
        );
      } catch (error) {
        this.loggingService.log('Caught Error: ' + error);
      }
      this.contentLoaded = false;
    }
  }

  updateResponse(response, campaignId) {
    if (this.peRequest?.userdata?.firstName) {
      response = response.replace(
        '{{FNAME}}',
        this.peRequest.userdata.firstName
      );
    }
    if (this._config.get('APP_HERO_PECALL')) {
      const accountCookie = this.cookieHelper.getCookieValue('account');
      if (accountCookie?.length) {
        const parseAccount = JSON.parse(accountCookie);
        this.corpName = parseAccount['name'];
        this.cdf.detectChanges();
      } else {
        // if from intranetlink
        const cookieIntranet = Object.assign(
          {},
          { hasCookie: this.cookieHelper.getCookies('corp') }
        );
        if (cookieIntranet?.hasCookie?.split('|')?.length > 1) {
          this.corpName = this.cookieHelper
            .getCookies('corp')
            .split('|')[1]
            .split('=')[1]
            .replace(/#/g, ' ');
        }
      }
      if (this.corpName) {
        const replacingString =
          campaignId === 'homepage:banner'
            ? decodeURIComponent(this.corpName)
            : decodeURIComponent(this.corpName).toUpperCase();
        response = response.replace(/{{CONAME}}/g, replacingString);
      }
    } else {
      if (this.peRequest?.userdata?.selectedCompany) {
        const replacingString =
          campaignId === 'homepage:banner'
            ? this.peRequest.userdata.selectedCompany
            : this.peRequest.userdata.selectedCompany.toUpperCase();
        response = response.replace(/{{CONAME}}/g, replacingString);
      }
    }
    const elementNat = this.elementRef.nativeElement.querySelectorAll(
      'a[data-extlink="ext12"]'
    );
    if (elementNat.length > 0) {
      for (let i = 0; i < elementNat.length; i++) {
        this.rend.listen(elementNat[i], 'click', (event) => {
          event.preventDefault();
          if (
            elementNat[i].getAttribute('href') &&
            elementNat[i].getAttribute('href') !== null
          ) {
            this.open(elementNat[i].getAttribute('href'));
          }
          return false;
        });
      }
    }
    return response;
  }

  stopTimeout() {
    for (let i = 0; i < this.timeouts.length; i++) {
      clearTimeout(this.timeouts[i]);
    }
    this.timeouts = [];
  }

  setupShoppingBandAnalytics(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    setTimeout(() => this.initializeShoppingBandListeners(), 100);
  }

  private initializeShoppingBandListeners(): void {
    const shoppingBand = this.getShoppingBandElement();
    if (!shoppingBand || this.isAnalyticsAlreadySetup(shoppingBand)) return;

    this.markAnalyticsAsSetup(shoppingBand);
    this.attachClickListeners(shoppingBand);
  }

  private getShoppingBandElement(): Element | null {
    return document.querySelector('.wrapper-shopping-band.shopping-band-4up');
  }

  private isAnalyticsAlreadySetup(element: Element): boolean {
    return element.hasAttribute('data-analytics-setup');
  }

  private markAnalyticsAsSetup(element: Element): void {
    element.setAttribute('data-analytics-setup', 'true');
  }

  private attachClickListeners(shoppingBand: Element): void {
    const links = shoppingBand.querySelectorAll('a[data-analytics-id]');
    links.forEach((link: HTMLAnchorElement) => {
      this.rend.listen(link, 'click', () => this.trackShoppingBandClick(link));
    });
  }

  trackShoppingBandClick(link: HTMLAnchorElement): void {
    const linkText = this.extractLinkText(link);
    const href = link.getAttribute('href') || '';
    const user = this.createBaseAnalyticsUser();

    if (this.contentBodyAbodeSupportAnalytics['isLoggedInGlobal']) {
      this.handleLoggedInUserAnalytics(linkText, href, user);
    } else {
      this.sendShoppingBandAnalytics(linkText, href, user);
    }
  }

  private extractLinkText(link: HTMLAnchorElement): string {
    return link.innerText?.trim().replace(/\s+/g, ' ') || '';
  }

  private createBaseAnalyticsUser(): AnalyticsUser {
    return {
      attributes: this.contentBodyAbodeSupportAnalytics.getUserAttributes(true)
    };
  }

  private handleLoggedInUserAnalytics(
    linkText: string,
    href: string,
    user: AnalyticsUser
  ): void {
    this.acctSummarySvr
      .getAccountSummaryDetails()
      .pipe(take(1))
      .subscribe((response) => {
        if (response && Object.keys(response).length > 0) {
          const { profile } =
            this.contentBodyClickEventAnalyticsUtils['buildAnalyticsProfile'](
              response
            );
          user.profile = profile;
        }
        this.sendShoppingBandAnalytics(linkText, href, user);
      });
  }

  private sendShoppingBandAnalytics(
    linkText: string,
    href: string,
    user: AnalyticsUser
  ): void {
    const analyticsData: ClickEventAnalytics = {
      event_detail: SHOPPING_BAND.EVENT_DETAIL,
      event: SHOPPING_BAND.EVENT,
      click: {
        name: linkText,
        type: SHOPPING_BAND.TYPE,
        page_section: SHOPPING_BAND.PAGE_SECTION,
        action:
          this.contentBodyAbodeSupportAnalytics['analyticsService'].getCleanUrl(
            href
          )
      },
      user
    };

    this.contentBodyAbodeSupportAnalytics['analyticsService'].setAnalytics(
      analyticsData
    );
  }

  customEvent_HeroContent() {
    try {
      if (isPlatformBrowser(this.platformId)) {
        this.elementRef.nativeElement.dispatchEvent(
          new CustomEvent('heroContentLoaded', {
            bubbles: true
          })
        );
      }
    } catch (err) {
      this.loggingService.log(
        'Caught Error in customEvent_HeroContent : ' + err
      );
    }
  }

  ngOnDestroy() {
    if (this.svcLoadHtmlFragmentSubcription) {
      this.svcLoadHtmlFragmentSubcription.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdf.detach();
    this.stopTimeout();
  }
}
